
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.0
 * @copyright  Copyright (C) 2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2025-11-05 (1.0.0) (jhoward)
 *    - Copy from Thanksgiving_defaultSection.vue component to Thanksgiving2025_defaultSection.vue component.
 *    - Update header image in Thanksgiving2025_defaultSection to the 2025 version.
 *    - Update background image in Thanksgiving2025_defaultSection to the 2025 version.
 *    - Customize menu type to "DINING" in Thanksgiving2025_defaultSection.
 *    - Modify styles in Thanksgiving2025_defaultSection to match 2025 branding and layout.
 */

import { defineComponent, PropType } from "vue";
import { ALLOWED_ITEM_COMPONENTS, Menu, MenuSection } from "../defs";
import DefaultVisualSection from "./visual/defaultVisualSection.vue";
import DefaultTextualSection from "./textual/defaultTextualSection.vue";

export default defineComponent({
  components: {
    DefaultTextualSection, DefaultVisualSection
  },
  name: "Thanksgiving2025_defaultSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    menuItemComponent: {
      type: String,
      default: "thanksgiving-food-item",
      validate: (value: string) => "" === value || ALLOWED_ITEM_COMPONENTS.indexOf(value)
    }
  },
  mounted() {
    this.section.ms_title = this.sectionTitle();
    this.section.ms_subtitle = this.sectionSubtitle();
  },
  methods: {
    sectionTitle(): string {
      if (this.section.ms_title.length && "thanksgiving dining" !== this.section.ms_title.toLowerCase().substring(0, 19)) {
        return this.section.ms_title;
      }

      return "DINING";
    },
    sectionSubtitle(): string {
      if (this.section.ms_subtitle.length) {
        return this.section.ms_subtitle;
      }

      return (this.menu?.page?.page_h1 || "");//.toUpperCase();
    }
  }
});
